import { STATUS_CHIP_VARIANTS } from "./constants";
import { BaseStatusChipProps } from "./types";

import "./styles.css";

const BaseStatusChip = ({
  label,
  variant = STATUS_CHIP_VARIANTS.NEUTRAL,
  icon,
  className,
}: BaseStatusChipProps) => (
  <span
    className={`base-status-chip base-status-chip-${variant} flex-inline items-center gap-100 body-s-regular ${className ?? ""}`}
  >
    {icon ? (
      <span className="flex-inline" aria-hidden>
        {icon}
      </span>
    ) : (
      <span className="base-status-chip-dot" aria-hidden />
    )}

    {label}
  </span>
);

export default BaseStatusChip;
